import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Options } from "qr-code-styling";

import "./GetAppContent.scss";
import QrCode from "../QrCode/QrCode";
import ImageAndroidLogo from "../../images/android-icon.svg";
import ImageAppleLogo from "../../images/apple-logo-white.svg";
import { AppDownloadPlatforms } from "../../utils/constants";
import { WEBPAGE } from "../../utils/constants/links";

const CUSTOM_QR_OPTIONS: Options = {
  width: 174,
  height: 174,
  type: "canvas",
  image: "",
  margin: 10,
  backgroundOptions: {
    color: "white",
    round: 0.2,
  },
  cornersDotOptions: {
    type: "square",
  },
  cornersSquareOptions: {
    type: "square",
  },
};

const downloadPlatforms = [
  { name: AppDownloadPlatforms.APPLE, image: ImageAppleLogo },
  { name: AppDownloadPlatforms.ANDROID, image: ImageAndroidLogo },
];

interface GetAppContentProps {
  className?: string;
}

export default function GetAppContent({ className = "" }: GetAppContentProps) {
  const { t } = useTranslation("games");

  return (
    <div className={`GetAppContent ${className}`}>
      <QrCode
        value={WEBPAGE.DOWNLOAD_HYPER_QRCODE_LINK}
        className="qrcode"
        customOptions={CUSTOM_QR_OPTIONS}
      />
      <Stack className="text-section">
        <p className="text-center main-copy">{t("get_the_app")}!</p>
        <p className="text-center sub-copy">
          {t("play_100s_of_games_with_no_ads_scan_qr")}
        </p>
      </Stack>
      <Stack gap={1} className="platform-section">
        <p className="available-on-text">{t("available_on")}</p>
        <div className="platform-icons">
          {downloadPlatforms.map((option) => (
            <span key={option.name} className="platform-icon">
              <Image src={option.image} alt={option.name} />
            </span>
          ))}
        </div>
      </Stack>
    </div>
  );
}
